import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Product } from '../../../../interfaces/Signature';
import usePageTitle from '../../../../services/hooks/usePageTitle';
import ProductItem from '../ProductItem/ProductItem';
import styles from './ProductsSection.module.scss';


interface ProductsSectionProps {
  data: Product[];
  title: string;
}

const ProductsSection: FC<ProductsSectionProps> = ({ title, data }): ReactElement => {
  const { t } = useTranslation();

  usePageTitle(t('pageTitle:appointment'));

  return (
    <section className={styles.productsSection}>
      <h4>{title}</h4>
      <ul>
        {data.map((item, index) => <ProductItem key={index} {...item} />)}
      </ul>
    </section>
  );
};

export default ProductsSection;
